// extracted by mini-css-extract-plugin
export var formContainer = "_ht-0";
export var message = "_ht-1";